import { render, staticRenderFns } from "./taskpreview-component.vue?vue&type=template&id=c23ce152"
import script from "./taskpreview-component.vue?vue&type=script&lang=ts"
export * from "./taskpreview-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports